<template>
	<div>
		<div style="margin-top: 25px;">
			<el-row  :gutter="12">
				<el-col :span="4">
					<el-select v-model="relation" @change="updateTable">
						<el-option value="0" label="全部"></el-option>
						<el-option value="1" label="本人"></el-option>
						<el-option value="2" label="下线"></el-option>
					</el-select>
				</el-col>
					<el-col :span="20">
					<div style="width: 100%;text-align: right;">
						<el-select style="width: 110px;" v-model="selectValue" placeholder="全部类型">
							<el-option label="代理商ID" value="1"></el-option>
							<el-option label="订单时间" value="2"></el-option>
						</el-select>
						<el-input type="text" style="width: 235px;margin-left: 3px;" v-model="queryValue" placeholder="请输入" v-if="isInput"></el-input>
						<el-date-picker
							style="width: 235px;margin-left: 3px;"
							v-model="time"
							v-if="!isInput"
							type="daterange"
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							format="yyyy-MM-dd">
						</el-date-picker>
						<el-button type="primary" style="margin-left: 3px;" icon="el-icon-search" @click="updateTable">搜索</el-button>
					</div>
				</el-col>
			</el-row>
		</div>
		<div style="margin-top: 15px;">
			<el-table ref="multipleTable" 
				 :data="tableData" 
				 style="width: 100%" 
				 element-loading-text="数据正在加载中" 
				 @selection-change="handleSelectionChange"
				 :header-cell-style="headClass"
			 	 :row-style="rowClass">
		      <el-table-column type="selection" width="50"></el-table-column>
		      <el-table-column prop="agentId" label="代理商ID" sortable></el-table-column>
		      <el-table-column prop="name" label="代理商"></el-table-column>
		      <el-table-column prop="relation" label="关系"></el-table-column>
		      <el-table-column label="付款金额">
                  <template slot-scope="scope">
				      		<div>
                                <span>{{moneyFormat(scope.row.money)}}</span>
				      		</div>
				      	</template>
              </el-table-column>
		      <el-table-column prop="posttime" label="付款时间" :formatter="dateFormat"></el-table-column>
		      <el-table-column prop="serialNumber" label="单号"></el-table-column>
		      <!-- <el-table-column label="操作">
		      	<template slot-scope="scope">
		      		<button @click="getMessage(scope.row)">查看</button>
		      	</template>
		      </el-table-column> -->
		    </el-table>
		    <el-pagination background
	    			style="text-align:right;margin-top: 15px;margin-bottom: 55px;"
		            @size-change="handleSizeChange"
		            @current-change="handleCurrentChange"
		            :current-page="currentPage"
		            :page-sizes="[10, 50, 100, 200]"
		            :page-size="pageSize" 
		            layout="total, sizes, prev, pager, next, jumper"
		            :total="total">
		    </el-pagination>
		</div>
	</div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'revenue',
  components: {
  },
  data() {
    return {
    	total: 0,
        currentPage: 1,
　　  	pageSize: 10,
		tableData:[],
		multipleSelection:[],
		relation:"0",
		queryValue:"",
		time:[]
    }
  },
  watch: {
  },
  computed:{
  	isInput:function(){
  		if(this.selectValue != "2"){
  			this.queryValue = "";
  			return true;
  		}else{
  			return false;
  		}
  	}
  },
  mounted() {
  	this.updateTable();
  },
  beforeDestroy() {
  },
  methods: {
  	handleSelectionChange(val) {
      this.multipleSelection = val;
    },
  	handleSizeChange(val) {
      this.pageSize = val;
      this.updateTable();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.updateTable();
    },
    updateTable(){
    	var thiz = this;
    	var param = {
  				pageId:this.currentPage,
  				size:this.pageSize
  			}
    	if(this.relation == 1 || this.relation == 2){
    		param.relation = this.relation;
    	}
  		if(this.selectValue == "1" && this.queryValue != ""){
  			param.searchAgentId = this.queryValue;
  		}else if(this.selectValue == "2" && this.queryValue != ""){
  			if(this.time != null && this.time.length > 0){
	  			param.beginTime = this.getStandardDate(this.time[0]);
	  			param.endTime = this.getStandardDate(this.time[1]);
	  		}
  		}
  		const loading = this.$loading({
          lock: true,
          text: '获取表格数据中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
          loading.close();
        }, 3000);
    	axios.get(this.$store.getters.getApiValue+'/srsAgent/searchSalesListByUid.do',{
  			params:param
  		}).then(function (response) {
  			loading.close();
		    var data = response.data;
		    if(data.status == "200"){
		    	thiz.total = data.totalCount;
		    	thiz.tableData = data.data;
		    }else{
		    	thiz.$message.error(data.message);
		    }
		  }).catch(function (error) {
		  	loading.close();
		    console.log(error);
		    thiz.$message.error("系统异常，请与管理员联系!");
		  });
    },
    dateFormat(row,column){
		var str = row[column.property];
		if(str == null || str == ""){
			return "";
		}else{
			return this.getStandardDate(new Date(str));
		}
	},
	getStandardDate(val){
    	var year = val.getFullYear();
        var month = val.getMonth() + 1;
        var day = val.getDate();
        month = month < 10 ? "0"+month : month;
        day = day < 10 ? "0"+day : day;
        return year+"-"+month+"-"+day;
   	},
    headClass({ row, rowIndex}) {
    	if(rowIndex == 0){
    		return ''
    	}
	    return ''
	},
    rowClass({ row, rowIndex}) {
	    if(rowIndex%2 == 0){
	    	return 'background:#F1F2F7;'
	    }else{
	    	return 'background:white;'
	    }
	    return ''
	},
	getMessage(row){
		
    },
    moneyFormat(val){
        val = val.toString().replace(/[^\d.]/g,""); //清除"数字"和"."以外的字符
        let val1 = parseFloat(val).toFixed(2);  //保留两位小数
        let val2 = val1.toString();
        let arr = val2.split('.');
        let arr1 = arr[0].split('');
        let str3 = "";
        let arr2 = [];
        for(let i=arr1.length-1,j=0;i>=0;i--,j++) {
          str3 = '' + arr1[i] + str3;
          if(j%3==2) {
            arr2.unshift(str3)
            str3 = "";
          }else if(i==0) {
            arr2.unshift(str3)
          }
        }
        let str4 = arr2.join(',');
        let str5 = str4 + '.' + arr[1];
        return str5;
    }
  }
}
</script>

<style>
  .el-table{
  	font-size: 12px;
  	border-bottom: 1px solid #dcd8d8;
  	color: black;
  }
  .el-table tr th{
  	border-top: 0px;
  	border-left: 0px;
  	border-right: 0px;
  }
  .el-table tr td{
  	border-bottom: 1px solid #dcd8d8;
  }
</style>